{
    "name": "ds-web",
    "version": "2026.4.0",
    "scripts": {
        "ng": "ng",
        "start": "ng serve -c local",
        "ngrok": "ng serve -c ngrok",
        "local-dev": "ng serve -c local-dev",
        "local-acc": "ng serve -c local-acc",
        "local": "ng serve -c local",
        "local-android": "ng serve -c local --host 127.0.0.1",
        "local-dev-android": "ng serve -c local-dev --host 127.0.0.1",
        "build-dev": "ng build -c dev",
        "build": "ng build",
        "test": "node tools/run-tests.mjs",
        "test:browser": "node tools/run-tests.mjs --browser",
        "test:ci": "node tools/run-tests.mjs",
        "verify:ci": "npm run lint && npm run test:ci && npm run test:browser && npm run build_lib && npm run build -- --configuration=production",
        "lint": "ng lint",
        "watch_lib": "ng build digital-signage --watch",
        "build_lib": "ng build digital-signage",
        "publish_lib": "npm publish ./dist/digital-signage --registry=https://nuget.cubigo.com/npm/Cubigo/",
        "sonar-scanner": "sonar-scanner"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "20.3.21",
        "@angular/common": "20.3.21",
        "@angular/compiler": "20.3.21",
        "@angular/core": "20.3.21",
        "@angular/forms": "20.3.21",
        "@angular/platform-browser": "20.3.21",
        "@angular/platform-browser-dynamic": "20.3.21",
        "@angular/router": "20.3.21",
        "@angular/service-worker": "20.3.21",
        "@angular/youtube-player": "20.2.11",
        "@cubigo/contracts": "~2026.4.0",
        "buffer": "6.0.3",
        "@js-joda/core": "5.6.5",
        "@ngrx/effects": "20.1.0",
        "@ngrx/store": "20.1.0",
        "@microsoft/applicationinsights-web": "3.3.10",
        "@ngx-translate/core": "17.0.0",
        "@ngx-translate/http-loader": "17.0.0",
        "@types/pubnub": "7.2.1",
        "angular-oauth2-oidc": "20.0.2",
        "gettext-parser": "8.0.0",
        "pubnub": "7.4.0",
        "rxjs": "7.8.2",
        "tslib": "2.8.1",
        "util": "0.12.5",
        "zone.js": "0.15.1"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "20.3.26",
        "@angular-eslint/builder": "20.7.0",
        "@angular-eslint/eslint-plugin": "20.7.0",
        "@angular-eslint/eslint-plugin-template": "20.7.0",
        "@angular-eslint/schematics": "20.7.0",
        "@angular-eslint/template-parser": "20.7.0",
        "@angular/build": "20.3.26",
        "@angular/cli": "20.3.22",
        "@angular/compiler-cli": "20.3.21",
        "@eslint/compat": "1.2.3",
        "@eslint/eslintrc": "3.2.0",
        "@eslint/js": "9.15.0",
        "@stylistic/eslint-plugin": "^2.11.0",
        "@stylistic/eslint-plugin-ts": "^2.11.0",
        "@types/gettext-parser": "4.0.4",
        "@types/jasmine": "5.1.4",
        "@vitest/browser": "3.2.4",
        "@vitest/coverage-v8": "3.2.4",
        "@typescript-eslint/eslint-plugin": "8.57.2",
        "@typescript-eslint/parser": "8.57.2",
        "eslint": "9.39.2",
        "eslint-plugin-import": "latest",
        "eslint-plugin-jsdoc": "latest",
        "eslint-plugin-prefer-arrow": "latest",
        "jasmine-core": "5.4.0",
        "jsdom": "26.1.0",
        "karma": "6.4.4",
        "karma-chrome-launcher": "3.2.0",
        "karma-coverage": "2.2.1",
        "karma-jasmine": "5.1.0",
        "karma-jasmine-html-reporter": "2.1.0",
        "karma-sonarqube-reporter": "1.4.0",
        "ng-packagr": "20.3.0",
        "playwright": "1.55.1",
        "sonarqube-scanner": "3.5.0",
        "typescript": "5.9.3",
        "vitest": "3.2.4"
    }
}
